// extracted by mini-css-extract-plugin
export default {"ButtonClose":"ButtonClose_ButtonClose__g0X3G"};